import axios from "axios";
import { localIp } from "../../constants";
import { Role, Uav } from "./types";
import { API } from "aws-amplify";

import { store } from "../../app/store";

const p1Secret = process.env.REACT_APP_PILOT_SECRET;
const observerSecret = process.env.REACT_APP_OBSERVER_SECRET;

export const bind = async (
  role?: Role,
  ip?: string,
  port: string = ":5000",
) => {
  if (role === "observer") {
    const secret = observerSecret;
    const res = await axios.get<{ token: string }>(
      `https://${ip}${port}/token?username=${role}&password=${secret}`,
      { timeout: 8000 }
    );
    return res;
  }
  const secret = p1Secret;
  const searchParams = new URLSearchParams(window.location.search);
  const sslParam = searchParams.get("ssl");
  const protocol = sslParam === "false" ? "http" : "https";
  const position = {
    latitude: 0,
    longitude: 0,
  };
  const url = `${protocol}://${
    ip?.includes("localhost") ? ip : ip
  }${port}/tether?username=${role}&password=${secret}&lat=${
    position?.latitude
  }&lon=${position?.longitude}`;

  const res = await axios.get<{ token: string }>(url, { timeout: 8000 });
  return res;
};
const path = "/mission";

/*
/mission/cancel [PUT]
Permitted roles: P1, P2
*/
export const cancel = (token: string, url: string, port: string = ":5000") => {
  return axios.put<string>(
    `https://${url}${port}${path}/cancel`,
    {},
    {
      headers: { Authorization: "Bearer " + token },
      timeout: 8000,
    }
  );
};
/*
/mission/deliver [PUT]
Permitted roles: P1, P2
*/
export const deliver = (token: string, url: string, port: string = ":5000") => {
  return axios.put<string>(
    `https://${url}${port}${path}/deliver`,
    {},
    {
      headers: { Authorization: "Bearer " + token },
      timeout: 8000,
    }
  );
};
/*
/mission/land [PUT]
Permitted roles: P1, P2
*/
export const land = (token: string, url: string, port: string = ":5000") => {
  return axios.put<string>(
    `https://${url}${port}${path}/land`,
    {},
    {
      headers: { Authorization: "Bearer " + token },
      timeout: 8000,
    }
  );
};
/*
/mission/arm [PUT]
Permitted roles: P1, P2
*/
export const arm = (token: string, url: string, port: string = ":5000") => {
  return axios.put<string>(
    `https://${url}${port}${path}/arm`,
    {},
    {
      headers: { Authorization: "Bearer " + token },
      timeout: 8000,
    }
  );
};

/*
/mission/smartrtl [PUT]
Permitted roles: P1, P2
*/

export const smartRtl = (
  token: string,
  url: string,
  port: string = ":5000"
) => {
  return axios.put<string>(
    `https://${url}${port}${path}/smartrtl`,
    {},
    {
      headers: { Authorization: "Bearer " + token },
      timeout: 8000,
    }
  );
};

/*
/mission/rtl [PUT]
Permitted roles: P1, P2
*/
export const rtl = (token: string, url: string, port: string = ":5000") => {
  return axios.put<string>(
    `https://${url}${port}${path}/rtl`,
    {},
    {
      headers: { Authorization: "Bearer " + token },
      timeout: 8000,
    }
  );
};

export const ping = async (ip: string, port: string = ":5000") => {
  const searchParams = new URLSearchParams(window.location.search);
  const sslParam = searchParams.get("ssl");
  const protocol = sslParam === "false" ? "http" : "https";
  const res = await axios.get<{ token: string }>(
    `${protocol}://${ip}${port}/healthinfo/time`,
    { timeout: 8000 }
  );
  return res;
};
export const localPing = async () => {
  return await ping(localIp);
};

export const autoarm = (token: string, url: string, port: string = ":5000") => {
  return axios.put(
    `https://${url}${port}/maintenance/autotakeoff`,
    {},
    {
      headers: { Authorization: "Bearer " + token },
    }
  );
};

export const getAircraftList = async (): Promise<Uav[]> => {
  return API.get("core", `/uav/list`, {});
};
